<template>
    <slot>
        <div class="row">
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">VDS Account</label>
            <v-select
                v-model="formData.vat_challan_account_head_id"
                placeholder="Select VAT Challan Receivable"
                class="w-100"
                :options="vatChallanHeads"
                label="name"
                :reduce="(name) => name.id"
            />
          </div>
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">VDS Amount</label>
            <vField
                v-model="formData.vat_challan_amount"
                name="amount"
                type="number"
                class="form-control text-right"
                @keyup="validateTDSVDSAmount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">AIT Accounts</label>
            <v-select
                v-model="formData.ait_challan_account_head_id"
                placeholder="Select AIT Challan Receivable"
                class="w-100"
                :options="aitChallanHeads"
                label="name"
                :reduce="(name) => name.id"
            />
          </div>
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">AIT Amount</label>
            <vField
                v-model="formData.ait_challan_amount"
                name="amount"
                type="number"
                class="form-control text-right"
                @keyup="validateTDSVDSAmount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">Discount Account</label>
            <v-select
                v-model="formData.discount_account_head_id"
                placeholder="Select Discount Account"
                class="w-100"
                :options="discountAccountHeads"
                label="name"
                :reduce="(name) => name.id"
            />
          </div>
          <div class="col-12 col-md-6" v-if="!isPosInvoice">
            <label for="colFormLabel" class="col-form-label">Discount Amount</label>
            <vField
                v-model="formData.discount_amount"
                name="amount"
                type="number"
                class="form-control text-right"
                @keyup="validateTDSVDSAmount"
            />
          </div>
        </div>

        <div class="row mb-1">
            <div class="col-12 col-md-6">
                <vField
                    v-model="props.grandTotal"
                    name="total"
                    type="number"
                    v-if="false"
                    class="form-control text-right"
                    disabled="disabled"
                />
                <label for="colFormLabel" class="col-form-label">Mode Of Payment</label>
                <v-select
                    placeholder="Select Cash & Bank Account"
                    class="w-100"
                    v-model="formData.mop_account_head_id"
                    name="mop_account_head_id"
                    :options="cashAndBank"
                    label="name"
                    :reduce="name => name.id"
                />
            </div>
            <div class="col-12 col-md-6 mb-1">
              <label for="colFormLabel" class="col-form-label">Paid Amount</label>
                <vField
                    v-model="formData.payment"
                    name="amount"
                    type="number"
                    class="form-control text-right"
                    @keyup="validatePaymentAmount"
                />
            </div>
        </div>
      <div class="row mb-1">
        <div class="col-12 col-sm-6">
            <label class="form-label" for="mopReference">MoP Reference</label>
            <vField
                v-model="formData.receipt_reference"
                name="receipt_reference"
                type="text"
                class="form-control"
            />
          </div>
      </div>
        <div class="row mb-1" v-if="false">
            <div class="col-12 col-md-6">
                <label class="form-label" for="receivedAmount">Total Collection</label>
                <vField
                    v-model="receivedAmount"
                    name="receivedAmount"
                    type="number"
                    class="form-control text-right"

                />
            </div>
            <div class="col-12 col-md-6 d-flex align-items-end">
                <h4>Change Amount: <b>{{ changeAmount }} BDT</b></h4>
            </div>
        </div>
    </slot>
</template>

<script setup>
import {computed, inject, onMounted, ref, watch, watchEffect} from "vue";
import {useRoute} from "vue-router";

const $router = useRoute();
const formData = inject('formData')
const showError = inject('showError')
const props = defineProps({
    grandTotal: {
        type: Number
    },
    isHospitalInvoice: {
        type: Boolean,
        default: false
    },
    isPosInvoice:{
      type:Boolean,
      default:false
    },
    cashAndBank: {
        type: Array,
        default: () => []
    },
    vatChallanHeads: {
        type: Array,
        default: () => []
    },
    aitChallanHeads: {
        type: Array,
        default: () => []
    },
    discountAccountHeads: {
        type: Array,
        default: () => []
    }
})

const companyId = $router.params.companyId;
const receivedAmount = ref(null)

const setInitialValue = (array, field) => {
    if(!array.length) return;
    formData.value[field] = array[0].id
}

watchEffect(() => {
    formData.value.payment = '';
    if(!props.grandTotal || !props.isHospitalInvoice) return;
    formData.value.payment = props.grandTotal;
});

const totalAmount = computed(() => props.grandTotal)

const validatePaymentAmount = (event) => {
    const amount = event.target.value
    if (amount < 0) {
        showError("Payment Amount cannot be less than 0")
    }

    let amountValue = parseFloat(amount)
    let totalAmountValue = parseFloat(totalAmount.value)

    if (amountValue > totalAmountValue) {
      formData.value.payment = totalAmountValue
    }
}

const validateTDSVDSAmount = (event) => {
  const amount = event.target.value
  if (amount < 0) {
    showError("Payment Amount cannot be less than 0")
  }

  let ait = parseFloat(formData.value.ait_challan_amount) || 0;
  let vat = parseFloat(formData.value.vat_challan_amount) || 0;
  let discount = parseFloat(formData.value.discount_amount) || 0;
  const totalDeductions = ait + vat + discount;

  formData.value.payment = totalAmount.value - totalDeductions;
}

const changeAmount = computed(() => {
    if (formData.value.payment > 0 && receivedAmount.value && receivedAmount.value > 0) {
        return receivedAmount.value - formData.value.payment;
    }
    return 0
})

const generateMoneyReceiptNumber = async () => {
    setInitialValue(props.cashAndBank, 'mop_account_head_id');
    receivedAmount.value = null;
}

onMounted(() => {
    generateMoneyReceiptNumber();
    setInitialValue(props.cashAndBank, 'mop_account_head_id');
})

defineExpose({generateMoneyReceiptNumber})
</script>
